import { callBackendApi } from "../../../../../../components/service/axios";

export const getAppUserAccess = async (appId) => {
  return await callBackendApi("get", `/bff/apps/${appId}/user-accesses`);
};
